import { render } from "./dzjyDetail.vue?vue&type=template&id=d30222e4&scoped=true&ts=true"
import script from "./dzjyDetail.vue?vue&type=script&lang=ts"
export * from "./dzjyDetail.vue?vue&type=script&lang=ts"

import "./dzjyDetail.vue?vue&type=style&index=0&id=d30222e4&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d30222e4"]])

export default __exports__